"use client";

import { useRouter } from "next/navigation";
import { ImageryRequestPage } from "@/components/imagery/ImageryRequestPage";
import { useImageryLandingSession } from "@/contexts/ImageryLandingSessionContext";

export default function ImageryLandingPage() {
	const router = useRouter();
	const { status } = useImageryLandingSession();

	if (status === "idle" || status === "checking") {
		return (
			<div className="grid min-h-dvh w-full grid-cols-1 lg:grid-cols-2 lg:items-stretch">
				<div className="hidden min-h-[40vh] bg-gradient-to-br from-[#16251c] to-[#0f1b13] lg:block lg:min-h-dvh" />
				<div className="min-h-[40vh] bg-gray-50 lg:min-h-dvh" />
			</div>
		);
	}

	if (status === "guest") {
		return (
			<ImageryRequestPage
				chrome="guest"
				onSubmit={() => router.push("/imagery/request/new")}
				onCheckIn={() => router.push("/imagery/requests")}
			/>
		);
	}

	// authenticated or error (still Cognito session; shell shows minimal header)
	return (
		<ImageryRequestPage
			chrome="loggedIn"
			onSubmit={() => router.push("/imagery/request/new")}
			onCheckIn={() => router.push("/imagery/requests")}
		/>
	);
}
